import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, HostListener, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { IdleService } from 'src/app/services/idle/idle.service';
import { TranslateService } from '@ngx-translate/core';
import { Sidebar, SidebarContainer } from 'ngx-angular-sidebar';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { AllowNotificationComponent } from 'src/app/components/allow-notification/allow-notification.component';
import { NewHiresModalComponent } from 'src/app/components/new-hires-modal/new-hires-modal.component';
import { ChatService } from 'src/app/services/chat/chat.service';
import { MenuService } from 'src/app/services/menu/menu.service';
import { UserDataService } from 'src/app/services/userData/user-data.service';
import { UtilService } from 'src/app/services/util/util.service';
import { ConsentmentTermComponent } from './../../components/consentment-term/consentment-term.component';
import { AuthService } from './../../services/auth/auth.service';
import { ConsentmentTermService } from './../../services/consentmentTerm/consentment-term.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SignatureScreenComponent } from 'src/app/components/signature-screen/signature-screen.component';
import { SocketService } from 'src/app/services/socket/socket.service';
import { VoipService } from 'src/app/services/voip/voip.service';
import { HeaderComponent } from '../../components/header/header.component';
import { NgClass } from '@angular/common';
import { PerfectScrollbarComponent } from 'ngx-perfect-scrollbar-portable';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { QuickviewComponent } from '../../components/quickview/quickview.component';
import { VoipCallComponent } from '../../components/voip-call/voip-call.component';
import { ConferencePipComponent } from '../conference/components/conference-pip.component';
import { ConsentmentTermComponent as ConsentmentTermComponent_1 } from '../../components/consentment-term/consentment-term.component';
import { NewHiresModalComponent as NewHiresModalComponent_1 } from '../../components/new-hires-modal/new-hires-modal.component';
import { AllowNotificationComponent as AllowNotificationComponent_1 } from '../../components/allow-notification/allow-notification.component';
import { ChatWindowComponent } from '../../components/chat-window/chat-window.component';
import { ChatbotWindowComponent } from '../../components/chatbot-window/chatbot-window.component';
import { SafeUrlPipe } from 'src/app/pipes/safeUrl/safe-url.pipe';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [HeaderComponent, SidebarContainer, NgClass, Sidebar, PerfectScrollbarComponent, SidebarComponent, RouterOutlet, QuickviewComponent, VoipCallComponent, ConferencePipComponent, ConsentmentTermComponent_1, NewHiresModalComponent_1, AllowNotificationComponent_1, SignatureScreenComponent, ChatWindowComponent, ChatbotWindowComponent, SafeUrlPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements OnInit, AfterViewInit {
  menu = inject(MenuService);
  util = inject(UtilService);
  as = inject(AuthService);
  private idleService = inject(IdleService);
  translate = inject(TranslateService);
  localeService = inject(BsLocaleService);
  cs = inject(ConsentmentTermService);
  userdata = inject(UserDataService);
  ch = inject(ChatService);
  private breakpointObserver = inject(BreakpointObserver);
  router = inject(Router);
  private socketService = inject(SocketService);
  private voipService = inject(VoipService);
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  @ViewChild('sidebar') sidebar: Sidebar;
  @ViewChild('consentmentTerm') consentmentTerm?: ConsentmentTermComponent;
  @ViewChild('allowNotification') allowNotification?: AllowNotificationComponent;
  @ViewChild('newHire') newHire?: NewHiresModalComponent;
  @ViewChild('signature') signature?: SignatureScreenComponent;
  dockedSize: string = '70px';
  configuration: any;

  @HostListener('document:click', [])
  @HostListener('document:keydown', [])
  onUserInteraction(): void {
    this.ch.unlockAudio();
  }

  ngOnInit(): void {
    // Registra o listener de VOIP JÁ: o <app-voip-call> está num @defer
    // (on idle) e o init() dele só rodava quando o browser ficasse ocioso —
    // chamada recebida nos primeiros segundos pós-login caía no vazio.
    // init() é idempotente (guard interno), o componente re-chama sem efeito.
    this.voipService.init();

    this.idleService.watch();
    this.ch.checkUserChatByRequest().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.cdr.markForCheck();
    });
    this.breakpointObserver.observe([Breakpoints.Handset]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
      this.dockedSize = result.matches ? '0px' : '70px';
      this.cdr.markForCheck();
    });

    if (localStorage.getItem('menuMode')) {
      this.menu.mode = localStorage.getItem('menuMode').toString();
      if (this.menu.mode == "push") {
        this.menu.dock = true;
        this.menu.opened = true;
      } else {
        this.menu.dock = true;
        this.menu.opened = false;
      }
    } else {
      if (window.innerWidth >= 992) {
        this.menu.mode = "push";
        this.menu.dock = true;
        this.menu.opened = true;
      } else {
        this.menu.mode = "over"
        this.menu.dock = false;
        this.menu.opened = false;
      }
    }

    setTimeout(() => {
      this.sidebar.triggerRerender();
      this.menu.sidebarAnimated = true;
    }, 10000);
  }  

  ngAfterViewInit(): void {
    this.util.getServerConfiguration().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      this.configuration = data;
      this.as.checkToken();

      this.menu.getLoggedUser().then(() => {
        if (this.menu.loggedUser) {
          this.userdata.getLoggedUserStatus().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: any) => {
            if (response?.statusString !== 'PENDENTE' && response?.statusString !== 'RECUSOU_TERMO') {
              this.loadAllowNotification();
            } else {
              this.cs.getLastConsentmentTerm().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result: any) => {
                if (result) {
                  this.consentmentTerm?.show(result);
                } else {
                  this.loadAllowNotification();
                }
                this.cdr.markForCheck();
              });
            }
          }, err => {
            setTimeout(() => {
              this.loadAllowNotification();
            }, 1500);
          });

          if (this.menu.loggedUser.preferredLocale) {
            if (this.menu.loggedUser.preferredLocale.indexOf('es') !== -1) {
              this.translate.setFallbackLang('es');
              this.translate.use('es');
              this.localeService.use('es');
            } else if (this.menu.loggedUser.preferredLocale.indexOf('en') !== -1) {
              this.translate.setFallbackLang('en');
              this.translate.use('en');
              this.localeService.use('en');
            } else if (this.menu.loggedUser.preferredLocale.indexOf('pt-PT') !== -1) {
              this.translate.setFallbackLang('pt-PT');
              this.translate.use('pt-PT');
              this.localeService.use('pt-PT');
            } else {
              this.translate.setFallbackLang('pt-BR');
              this.translate.use('pt-BR');
              this.localeService.use('pt-br');
            }
            setTimeout(() => {
              this.util.getEmojiLabelsTranslated();
            }, 600);
          }
        }
      });

      if (this.configuration && this.configuration.srcCss) {
        this.addCSS();
      }

      if (this.configuration && this.configuration.srcScript) {
        this.addScriptSrc();
      }

      if (this.configuration && this.configuration.inlineScript) {
        this.addInlineScript();
      }

      this.socketService.genericSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((message: any) => {
      if (message?.type === "NEW_REQUIRED_SIGNATURE") {
        this.signature?.showModal();
      }
      this.cdr.markForCheck();
    });

      this.menu.checkIsAdminstrator();
      this.menu.getLoggedUserId();
      this.cdr.markForCheck();

    }, err => {
      this.as.noConnection = true;
      this.cdr.markForCheck();
    });
  }

  showConsentmentTerm() {
    this.consentmentTerm?.show(this.menu.consentmentTermUser.consentmentTerm, true);
  }

  loadAllowNotification() {
      this.allowNotification?.accept();
      this.loadModals();
  }

  loadModals() {
    this.newHire?.showFormModal();
  }
  addCSS() {
    const css = document.createElement('link');
    css.setAttribute('rel', 'stylesheet');
    css.setAttribute('type', 'text/css');
    css.setAttribute('href', this.configuration.srcCss);
    document.body.appendChild(css);
  }

  addScriptSrc() {
    const chatScript = document.createElement('script');
    chatScript.setAttribute('type', "text/javascript");
    chatScript.setAttribute('src', this.configuration.srcScript);
    document.head.appendChild(chatScript);
  }

  addInlineScript() {
    const newScript = document.createElement('script');
    const inlineScript = document.createTextNode(this.configuration.inlineScript);
    newScript.appendChild(inlineScript);
    document.body.appendChild(newScript);
  }
}
